import { ProductDetails } from "./components";

export function mapProductsData(data, questionnaireId, structure) {
  return data.map(el => {
    return {
      id: el.id,
      name: el.description,
      data: {
        ...el,
        questionnaireId,
        structure
      },
      component: ProductDetails,
      customTabListTitle: el.description,
      customTabListSubTitle: null,
      customTabPanelTitle: null
    };
  });
}